import React from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";

import colorPalette from "../Assets/color-palette-dynamic-color.webp";
import targetISO from "../Assets/bg/target-iso-color.webp";

function About() {
return (
<>
    <Navbar />
    <div className="p-3 bg-light-custom" id="aboutMe">
        <div className="container">
            <div className="row">
                <h1 className="fs-bold mt-4 text-purple">About me</h1>
                <div className="col">
                    <p>
                        I’m a skilled web developer, web enthusiast, tech geek, and a
                        proactive individual who is passionate about computers,
                        technology, and music (Will soon create a Page which talks about
                        my musical interests).
                    </p>

                    <p>
                        You can find my work experience on
                        <a href="https://in.linkedin.com/in/g-rohit" target="_blank" rel="noopener" name="linkedin link"
                            aria-label="linkedin" class="external-link">
                            Linkedin
                        </a>
                        , and fun projects on
                        <a href="https://codepen.io/grohit/" target="_blank" name="codepen link" rel="noopener"
                            aria-label="CodePen" class="external-link">
                            Codepen
                        </a>
                        . I <em>occasionally</em> posts my designs on
                        <a href="https://www.behance.net/g-rohit" target="_blank" rel="noopener" name="Behance link"
                            aria-label="behance" title="Behance" class="external-link"
                            title="I mean I rarely post my designs here :(">
                            Behance
                        </a>
                        . Find my repos on
                        <a href="https://github.com/g-rohit" target="_blank" rel="noopener" name="github link"
                            aria-label="github" class="external-link">
                            Github
                        </a>
                        and stay connected on
                        <a href="https://instagram.com/developerGrohit" target="_blank" rel="noopener"
                            name="Instagram link" aria-label="Instagram" class="external-link">
                            Instagram
                        </a>
                        . If you would like to work with me,
                        <a href="mailto:social@grohit.com" class="external-link">
                            drop me an email
                        </a>
                        .
                    </p>
                </div>
            </div>
            <h3 className="mt-5 mb-4 fs-bold text-dark-purple cursive-underline">Skill Sets</h3>
            <div className="row mt-3 align-items-lg-start" id="skillSet">
                <div className="col-lg-2 col-md-6 order-2 order-md-1">
                    <h4 style={{ color: "#E84274" }}>Design</h4>
                    <p>UI/UX Design, Wireframing, Prototyping</p>
                </div>
                <div className="col-lg-4 col-md-6 order-3 order-md-2 ">
                    <h4 style={{ color: "#E08A1C" }}>Development</h4>
                    <p>
                        Bootstrap, CSS2/3, Express, GATSBY, Git, Github, HTML4/5,
                        JavaScript, jQuery, MongoDB, NPM, NextJs, Node.JS, React, Sass,
                        Tailwind, UIKit, WebPack, Wordpress
                    </p>
                </div>
                <div className="col-lg-3 col-md-6 order-4 order-md-3 ">
                    <h4 style={{ color: "#945F43" }}>Tools I use</h4>
                    <p>
                        Figma, Adobe XD, Adobe PS, VS Code, Adobe Dreamweaver, Source
                        tree, Postman
                    </p>
                </div>
                <div className="col-lg-3 col-md-6 order-sm-1 order-1 order-md-4 ">
                    <img src={colorPalette} alt="colorPalette" className="img-fluid moving-image" />
                </div>
            </div>
         

            {/* Certificates */}
            <h3 className="my-3 fs-bold text-dark-purple cursive-underline">Certificates:</h3>
                   
<div className="row mt-5 align-items-center">
    <div className="col-md-3 mb-4">
        <img src={targetISO} alt="target image" className="img-fluid moving-image shad" style={{maxWidth: '300px'}}/>
    </div>
    <div className="col-md-9">
    <p>
                        I am always enthusiast to expand my skillset by learning online in youtube
                        or by enrolling various courses. Below are some certificates I was awarded
                        as an acknowledgement for the courses that I have completed or the
                        skillset that I have leant.
                    </p>
    </div>
</div>

                   
            <div className="row my-5" id="certificates-table">
                <div className="col-md-12 table-responsive rounded rounded-3 shadow-lg p-3">
                    <table className="table  col-md-12 table-bordered mb-0">
                        <thead className="thead">
                            <tr>
                                <th className="p-3 text-white">Certificate Name</th>
                                <th className="p-3  text-white">Issued by</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    <a href="https://www.freecodecamp.org/certification/grohit/responsive-web-design"
                                        target="_blank" className="text-white text-start" rel="noopener noreferrer">
                                        Responsive Web Design&nbsp;<i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://www.freecodecamp.org" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">FreeCodeCamp.org
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    <a href="https://www.freecodecamp.org/certification/grohit/javascript-algorithms-and-data-structures"
                                        target="_blank" className="text-white text-start" rel="noopener noreferrer">
                                        JavaScript Algorithms and Data Structures <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://www.freecodecamp.org" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        FreeCodeCamp.org
                                    </a>
                                </td>
                            </tr>
                            {/* Salesforce Certs */}
                            <tr>
                                <td scope="row">
                                    <a href="https://www.salesforce.com/trailblazer/grohit"
                                        target="_blank" className="text-white text-start" rel="noopener noreferrer">
                                        Marketing Cloud Personalization Accredited Professional <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://trailhead.salesforce.com/en/credentials/marketingcloudemailspecialist" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        Salesforce
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    <a href="https://www.salesforce.com/trailblazer/grohit"
                                        target="_blank" className="text-white text-start" rel="noopener noreferrer">
                                        Salesforce Certified Marketing Cloud Email Specialist <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://trailhead.salesforce.com/en/credentials/marketingcloudemailspecialist" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        Salesforce
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    <a href="https://www.salesforce.com/trailblazer/grohit"
                                        target="_blank" className="text-white text-start" rel="noopener noreferrer">
                                        Salesforce Certified Marketing Cloud Administrator <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://trailhead.salesforce.com/en/credentials/marketingcloudadministrator" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        Salesforce
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    <a href="https://www.salesforce.com/trailblazer/grohit"
                                        target="_blank" className="text-white text-start" rel="noopener noreferrer">
                                        Salesforce Certified Associate <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://trailhead.salesforce.com/en/credentials/marketingcloudadministrator" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        Salesforce
                                    </a>
                                </td>
                            </tr>
                            {/* udemy certs */}
                            <tr>
                                <td scope="row">
                                    <a href="https://www.udemy.com/certificate/UC-99ZLUWPJ/" target="_blank"
                                        className="text-white text-start" rel="noopener noreferrer">
                                        Photoshop Beginners Mastery <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://www.udemy.com/" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        Udemy.com
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    <a href="https://www.udemy.com/certificate/UC-9HXGTGYT/" target="_blank"
                                        className="text-white text-start" rel="noopener noreferrer">
                                        Mastering Selections and Masks in Photoshop <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://www.udemy.com" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        Udemy.com
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    <a href="https://www.udemy.com/certificate/UC-PKV5TEEA/" target="_blank"
                                        className="text-white text-start" rel="noopener noreferrer">
                                        ServiceNow Administration <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://www.udemy.com" target="_blank" className="text-white text-start"
                                        rel="noopener noreferrer">
                                        Udemy.com
                                    </a>
                                </td>
                            </tr>
                            {/* oracle cert */}
                            <tr>
                                <td scope="row">
                                    <a href="https://www.youracclaim.com/badges/91149b62-f068-4134-8651-ec617d1cd585/"
                                        target="_blank" className="text-white text-start" rel="noopener noreferrer">
                                        Oracle Certified Professional, Java SE 6 Programmer <i className="fad fa-external-link-alt" />
                                    </a>
                                </td>
                                <td>
                                    <a href="https://www.youracclaim.com/organizations/oracle/badges" target="_blank"
                                        className="text-white text-start" rel="noopener noreferrer">
                                        Oracle
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

{/* social media icons and project CTA */}
            <section class="social d-flex align-items-center justify-content-between mt-3 mb-5 flex-column flex-md-row">
                <div class="social-icons mb-4 w-50 w-md-auto  text-center text-md-start">
                    <a href="https://in.linkedin.com/in/g-rohit" target="_blank" rel="noopener" name="linkedin link"
                        aria-label="linkedin" className="text-white text-start">
                        
                        <i class="fab fa-linkedin fa-2x"></i>
                    </a>
                    <a href="https://www.instagram.com/uiux.rohit/" target="_blank" rel="noopener" name="Instagram link"
                        aria-label="Instagram" className="text-white text-start">
                        
                        <i class="fab fa-instagram fa-2x"></i>
                    </a>
                    <a href="https://github.com/g-rohit" target="_blank" rel="noopener" name="github link"
                        aria-label="github" className="text-white text-start">
                        
                        <i class="fab fa-github fa-2x"></i>
                    </a>
                    <a href="https://www.behance.net/g-rohit" target="_blank" rel="noopener" name="Behance link"
                        aria-label="behance" title="Behance" className="text-white text-start">
                        <i class="fab fa-behance-square fa-2x" aria-hidden="true"></i>
                    </a>
                    <a href="https://www.freecodecamp.org/grohit" target="_blank" rel="noopener"
                        aria-label="freecodecamp" id="profile-link" className="text-white text-start">
                        
                        <i class="fab fa-free-code-camp fa-2x"></i>
                    </a>
                    <a href="https://codepen.io/grohit/" target="_blank" name="codepen link" rel="noopener"
                        aria-label="CodePen" className="text-white text-start">
                        
                        <i class="fab fa-codepen fa-2x"></i>
                    </a>
                    {/* <a href="https://twitter.com/developerRohit" target="_blank" rel="noopener" name="Twitter link"
                        aria-label="Twitter" className='btn'> <i class="fab fa-twitter-square fa-2x"></i> </a> */}
                </div>

                <div className="mb-4">
                    <Link to="/projects" className="button">
                    Check out my projects <i class="far fa-arrow-right" aria-hidden="true"></i>
                    </Link>
                </div>
            </section>
        </div>
    </div>
</>
);
}

export default About;
